import {GameNetworkBasicState} from 'src/network/states/GameNetworkBasicState';

export class RecodeGameNetworkBasicState extends GameNetworkBasicState {
	protected setupEvents(): void {
		super.setupEvents();
	}

	protected onAvalanche(): void {
		this.module.logic.avalanche(null);
	}

	protected onReelsRespinStarted(): void {
		this.module.logic.respin(null);
	}
}



// WEBPACK FOOTER //
// ./src/network/recode/states/RecodeGameNetworkBasicState.ts